import { ReactNode } from 'react';
import { RelatedInventoryRiskItem } from '../../../Api/Projects/projectsApi';
import { RiskBanner } from './RiskBanner';
import { RiskWidgetCard } from './RiskWidgetCard';
import { RISK_TIER_DEFAULT_LABELS } from './riskTierStyles';

export interface SingleAssetRiskWidgetProps {
  item: RelatedInventoryRiskItem;
  // Rendered inside the dark card, above Next Steps (the Status Update / executive summary slot).
  children?: ReactNode;
  className?: string;
}

// Single-item variant of the Risk & Summary widget: a tier-colored status banner
// ("{label}: {message}") over the dark summary card with the asset's Next Steps.
// Unscored items get no banner.
export const SingleAssetRiskWidget = ({ item, children, className }: SingleAssetRiskWidgetProps) => {
  const { riskTier, riskLabel, riskMessage, nextSteps } = item;
  const bannerText = riskTier
    ? [riskLabel || RISK_TIER_DEFAULT_LABELS[riskTier], riskMessage].filter(Boolean).join(': ')
    : '';

  return (
    <div
      className={`flex flex-col ${className ?? ''}`}
      data-testid="single-asset-risk-widget"
      data-cy="single-asset-risk-widget">
      <RiskWidgetCard
        fill
        banner={
          riskTier && (
            <RiskBanner
              tier={riskTier}
              testId="single-asset-risk-banner">
              {bannerText}
            </RiskBanner>
          )
        }>
        {children}
        {nextSteps && (
          <div
            className="mt-4"
            data-testid="single-asset-next-steps">
            <div className="text-sm font-semibold text-white mb-1">Next Steps</div>
            <ul className="list-disc pl-5">
              <li className="text-sm text-grey-3 whitespace-pre-line">{nextSteps}</li>
            </ul>
          </div>
        )}
      </RiskWidgetCard>
    </div>
  );
};
